let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("76n7a"), load("l253H"), load("izzmP")]).then(() => parcelRequire('8IDjP'));